"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditCustomerModal_1 = __importDefault(require("./EditCustomerModal"));
exports.default = EditCustomerModal_1.default;
